import { useState } from "react";
import { useTranslation } from "react-i18next";

const EditForm = ({article, commentId, parentId, comment, sendEditRequestFromChild, sendEditBoxCloseFromChild}) => {
    const { t } = useTranslation();
    const [commentData, setCommentData] = useState(comment);

    const handleCommentSubmit = (e) => {
        e.preventDefault();
        let requestData = {
            "NewsArticlesID" : article,
            "Comment" : commentData,
            "IsLiked" : false,
            "ParentID" : parentId,
            "ID" : commentId
        }
        sendEditRequestFromChild(requestData);
    };
    const handleOnChange = (e) => {
        e. preventDefault();
        setCommentData(e.target.value)
    };
    const handleEditBoxClose = (e) => {
        e. preventDefault();
        sendEditBoxCloseFromChild('comment');
    };

    return (
        <>
            <form onSubmit={(e) => handleCommentSubmit(e)}>
                <div className="flex space-x-3 items-center">
                    <div className="bg-background-normal rounded-full items-center pl-2 sm:pl-4 pr-1 sm:pr-2 py-0.5 sm:py-1.5 flex w-full justify-between">
                        <div onClick={(e) => handleEditBoxClose(e)} className="cursor-pointer">
                            <img src="../../../assets/icons/dashboard/cross.svg" alt="cross" />
                        </div>
                        <div className="border-l h-8 border-black-100 mx-2"></div>
                        <div className="w-full">
                            <input type="text" placeholder={ t("add your comments")} name="comment" value={commentData} onChange={(e) => handleOnChange(e)} className="focus:outline-none bg-background-normal placeholder:text-dark-gray w-full placeholder:capitalize" />
                        </div>
                        <button type={(commentData.length > 0 ? 'submit' : 'button')} className={ (commentData.length > 0 ? 'bg-blue-normal cursor-pointer' : 'bg-black-100 cursor-not-allowed') + " rounded-full p-2 md:p-3"}>
                            <img src="../../../assets/icons/dashboard/comment.svg" alt="comment" />
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default EditForm;